"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCaptureSection = void 0;
const zod_1 = require("zod");
exports.EmailCaptureSection = zod_1.z.object({
    type: zod_1.z.literal('EmailCapture'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().min(1, { message: 'Title is required' }).max(60, {
        message: 'Title is too long',
    }),
    description: zod_1.z.string().min(1, { message: 'Subtitle is required' }).max(240, {
        message: 'Subtitle is too long',
    }),
    displayAsPopup: zod_1.z.boolean().optional().nullable(),
    image: zod_1.z.string().optional().nullable(),
});
